import { render, staticRenderFns } from "./GRCRisksList.vue?vue&type=template&id=78000ba9&scoped=true&"
import script from "./GRCRisksList.vue?vue&type=script&lang=js&"
export * from "./GRCRisksList.vue?vue&type=script&lang=js&"
import style0 from "./GRCRisksList.vue?vue&type=style&index=0&id=78000ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78000ba9",
  null
  
)

export default component.exports